import { hasCapability, type User } from "../base";

export const ticket = {
  view: (user: User) => hasCapability(user, "ticket.view"),
  create: (user: User) => hasCapability(user, "ticket.create"),
  update: (user: User) => hasCapability(user, "ticket.update"),
  list: (user: User) => hasCapability(user, "ticket.list"),
  note: (user: User) => hasCapability(user, "ticket.note"),
  delete: (user: User) => hasCapability(user, "ticket.delete"),
};
